// import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import style from './device-detection.css';
import CheckboxButton from '../checkbox-button/checkbox-button.jsx';
import CloseButton from '.././share-modal/close-button.jsx';
import ReactModal from 'react-modal';
import ScreenClose from './images/screen-close.png';
import CameraClose from './images/camera-close.png';
import MicphoneClose from './images/micphone-close.png';
import Micphone from './images/micphone.png';
import bindAll from 'lodash.bindall';
import {scratchClick} from '../../utils/xes-analytice';
import {getDeviceStatus} from '../../utils';

class DeviceDetection extends React.Component {
    constructor (props) {
        super(props);
        
        bindAll(this, [
            'handleVideoChange',
            'handleAudioChange',
            'handleSetRecordState',
            'golink'
        ]);

        this.state = {
            videoType: this.props.record && this.props.record.video,
            audioType: this.props.record && this.props.record.audio,
            videoIniting: false
        };
    }
    componentDidMount () {
        this.initScreenVideo();
        this.initDeviceVideo();
    }
    componentWillUnmount () {
    }
    initScreenVideo (){
        setTimeout(() => {
            if (this.props.mediaRecorder && this.props.mediaRecorder.screenStream) {
                const screenVideo = document.getElementById('screenVideo');
                if (screenVideo) {
                    screenVideo.srcObject = this.props.mediaRecorder.screenStream;
                    screenVideo.onloadedmetadata = () => screenVideo.play();
                    screenVideo.play();
                }
            }
        }, 0);
    }
    initDeviceVideo (){
        setTimeout(() => {
            if (this.props.mediaRecorder && this.props.mediaRecorder.videoStream) {
                const deviceVideo = document.getElementById('deviceVideo');
                if (deviceVideo) {
                    deviceVideo.srcObject = this.props.mediaRecorder.videoStream;
                    deviceVideo.onloadedmetadata = () => deviceVideo.play();
                    deviceVideo.play();
                }
            }
        }, 0);
    }
    handleAudioChange (checked) {
        if (checked && this.props.mediaRecorder && !this.props.mediaRecorder.audioStream) {
            this.props.mediaRecorder.initAudio().then(() => {
                this.props.mediaRecorder.audioProcess();
            });
        }
        this.setState({audioType: checked});
    }
    handleVideoChange (checked) {
        const {mediaRecorder} = this.props;
        if (!mediaRecorder) return;
        this.setState({videoIniting: true});
        if (checked) {
            mediaRecorder.initVideo().then(() => {
                this.initDeviceVideo();
                this.setState({
                    videoIniting: false,
                    videoType: checked
                });
            });
        } else {
            mediaRecorder.stopStream('video');
            this.setState({
                videoIniting: false,
                videoType: checked
            });
        }
    }
    ScreenVideo (){
        if (this.props.mediaRecorder && this.props.mediaRecorder.screenStream) {
            return <video id="screenVideo" />;
        }
        return (<div className={style.screenClose}>
            <img src={ScreenClose} />
            <p>{'无法展示屏幕画面'}</p>
        </div>);
    }
    deviceVideo (){
        if (this.state.videoType) {
            return (<div>
                <video id="deviceVideo" />
                <span
                    // eslint-disable-next-line react/jsx-no-bind
                    onClick={() => this.golink('video')}
                    className={classNames(style.deviceBtn, style.buttonGreen)}
                >{'看不到画面'}</span>
            </div>);
        }
        return <div className={style.cameraClose}><img src={CameraClose} /></div>;
    }
    audioVolumeList (){
        const volumeTrans = parseInt((this.props.volume * 100) / 6.67, 10);
        const audioVolumeDomList = [];
        for (let i = 1; i < 16; i++) {
            if (i <= volumeTrans) {
                audioVolumeDomList.push(<span
                    key={i}
                    className={style.active}
                />);
            } else {
                audioVolumeDomList.push(<span key={i} />);
            }
        }
        return audioVolumeDomList;
    }
    deviceAudio (){
        if (this.state.audioType) {
            return (<div>
                <div className={style.micphoneVoice}>
                    <img src={Micphone} />
                    <div>
                        {this.audioVolumeList()}
                    </div>
                </div>
                <span
                    // eslint-disable-next-line react/jsx-no-bind
                    onClick={() => this.golink('audio')}
                    className={classNames(style.deviceBtn, style.buttonGreen)}
                >{'无声音波动'}</span>
            </div>);
        }
        return <div className={style.micphoneClose}><img src={MicphoneClose} /></div>;
    }
    handleSetRecordState () {
        const {videoType, audioType} = this.state;
        scratchClick('click_xiaohou_share_step2', {
            language: 'Scratch',
            editor: 'Scratch编辑器',
            scene: '社区创作',
            bundle_id: '',
            question_id: '',
            button_name: '开始录制',
            status: getDeviceStatus(videoType, audioType)
        });
        this.props.onSetRecordState('recording', videoType, audioType);
    }
    golink (type) {
        if (type === 'screen') {
            window.open('https://shimo.im/docs/8Nk6MaVlWLiRdOqL/');
            scratchClick('click_xiaohou_share_exception', {
                language: 'Scratch',
                editor: 'Scratch编辑器',
                scene: '社区创作',
                bundle_id: '',
                question_id: '',
                button_name: '看不到屏幕画面'
            });
        }
        if (type === 'video') {
            window.open('https://shimo.im/docs/N2A1Mpo9yXfBlwAD/');
            scratchClick('click_xiaohou_share_exception', {
                language: 'Scratch',
                editor: 'Scratch编辑器',
                scene: '社区创作',
                bundle_id: '',
                question_id: '',
                button_name: '看不到摄像头画面'
            });
        }
        if (type === 'audio') {
            window.open('https://shimo.im/docs/erAdPEjpaYt9jNAG/');
            scratchClick('click_xiaohou_share_exception', {
                language: 'Scratch',
                editor: 'Scratch编辑器',
                scene: '社区创作',
                bundle_id: '',
                question_id: '',
                button_name: '没有声音波动'
            });
        }
    }

    render () {
        const {videoType, audioType, videoIniting} = this.state;
        const {
            onCloseModal
        } = this.props;
        return (
            <ReactModal
                className={style.content}
                contentLabel="设备检测"
                isOpen
                onRequestClose={onCloseModal}
                overlayClassName={style.overlay}
                shouldCloseOnOverlayClick={false}
            >
                <CloseButton onClick={onCloseModal} />
                <div className={style.title}>{'设备检测'}</div>
                <div className={style.box}>
                    <div className={classNames(style.device, style.deviceScreen)}>
                        <p className={style.deviceTitle}>{'屏幕画面'}</p>
                        {this.ScreenVideo()}
                        <span
                            // eslint-disable-next-line react/jsx-no-bind
                            onClick={() => this.golink('screen')}
                            className={classNames(style.deviceBtn, style.buttonGreen)}
                        >{'看不到画面'}</span>
                    </div>
                    <div className={classNames(style.device, style.deviceVideo)}>
                        <p className={style.deviceTitle}>{'摄像头画面'}</p>
                        <CheckboxButton
                            className={style.checkboxButton}
                            defaultChecked={videoType}
                            onChange={this.handleVideoChange}
                            disabled={videoIniting}
                        />
                        {this.deviceVideo()}
                        
                    </div>
                    <div className={classNames(style.device, style.deviceAudio)}>
                        <p className={style.deviceTitle}>{'麦克风声音'}</p>
                        <CheckboxButton
                            className={style.checkboxButton}
                            defaultChecked={audioType}
                            onChange={this.handleAudioChange}
                        />
                        {this.deviceAudio()}
                    </div>
                </div>

                <div
                    className={classNames(style.buttonGreen, style.recordButton)}
                    // eslint-disable-next-line react/jsx-no-bind
                    onClick={this.handleSetRecordState}
                >
                    {'开始录制'}
                </div>
            </ReactModal>
        );
    }
}
DeviceDetection.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    mediaRecorder: PropTypes.any,
    onCloseModal: PropTypes.func,
    volume: PropTypes.number,
    // eslint-disable-next-line react/forbid-prop-types
    record: PropTypes.object,
    onSetRecordState: PropTypes.func
};

export default DeviceDetection;
